import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";

export const getOfferStatsByFloor = (floor?: number | null, floors?: number | null, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    if (!floor) {
        return null;
    }

    if (floor <= 4) {
        const key = "properties_on_low_floor" as const;
        const statsValues = stats?.[key];

        return statsValues && statsValues.total
            ? {
                  key,
                  label: "na niskim piętrze",
                  ...statsValues
              }
            : null;
    }

    if (floors && (floors - floor === 0 || floors - floor === 1)) {
        const key = "properties_on_high_floors" as const;
        const statsValues = stats?.[key];

        return statsValues && statsValues.total
            ? {
                  key,
                  label: "na wysokim piętrze",
                  ...statsValues
              }
            : null;
    }

    const key = "properties_on_middle_floors" as const;
    const statsValues = stats?.[key];

    return statsValues && statsValues.total
        ? {
              key,
              label: "na średnim piętrze",
              ...statsValues
          }
        : null;
};
import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";

export const getOfferStatsByFloor = (floor?: number | null, floors?: number | null, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    if (!floor) {
        return null;
    }

    if (floor <= 4) {
        const key = "properties_on_low_floor" as const;
        const statsValues = stats?.[key];

        return statsValues && statsValues.total
            ? {
                  key,
                  label: "na niskim piętrze",
                  ...statsValues
              }
            : null;
    }

    if (floors && (floors - floor === 0 || floors - floor === 1)) {
        const key = "properties_on_high_floors" as const;
        const statsValues = stats?.[key];

        return statsValues && statsValues.total
            ? {
                  key,
                  label: "na wysokim piętrze",
                  ...statsValues
              }
            : null;
    }

    const key = "properties_on_middle_floors" as const;
    const statsValues = stats?.[key];

    return statsValues && statsValues.total
        ? {
              key,
              label: "na średnim piętrze",
              ...statsValues
          }
        : null;
};
